import React, { Fragment } from "react";
import { Container } from "@material-ui/core";
import { Helmet } from "react-helmet";
import { SubmissionForm, BookPurchaseBanner } from "./components";
import { PageBanner } from "../../components";
import { AboutAuthor } from "../Home/components";

function AuthorSubmissions() {
  return (
    <Fragment>
      <Helmet>
        <title>Author Submissions</title>
      </Helmet>
      <PageBanner
        title="Author Submission"
        image="./assets/images/authorSub.png"
      />
      <Container>
        <SubmissionForm />
        <BookPurchaseBanner />
        <AboutAuthor />
      </Container>
    </Fragment>
  );
}

export default AuthorSubmissions;
